module.exports = new __parcel__URL__("bossfight_space_elixir_button_inactive.8cad188f.png").toString();